import React, { useRef, useState } from 'react';
import kmusicLogo from '../../../_assets/sass/pages/chatbot/kmusic.svg';
import captainKLogo from '../../../_assets/sass/pages/chatbot/captainK.svg';
import appStoreLogo from '../../../_assets/sass/pages/chatbot/applestore.svg';
import googlePlayLogo from '../../../_assets/sass/pages/chatbot/google-play.svg';



const AppList = (props) => {
    let { msg  } = props;
    const appData = Array.isArray(msg) ? msg[0] : msg;

    const scrollRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startX, setStartX] = useState(0);
    const [scrollLeft, setScrollLeft] = useState(0);

    if (!appData || appData.parentId !== 9) {
        return null;
    }

    const handleMouseDown = (e) => {
        setIsDragging(true);
        const slider = scrollRef.current;
        if (slider) {
            setStartX(e.pageX - slider.offsetLeft);
            setScrollLeft(slider.scrollLeft);
            slider.style.cursor = 'grabbing';
            slider.style.userSelect = 'none';
        }
    };

    const handleMouseUp = () => {
        setIsDragging(false);
        const slider = scrollRef.current;
        if (slider) {
            slider.style.cursor = 'grab';
            slider.style.userSelect = 'auto';
        }
    };

    const handleMouseMove = (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const slider = scrollRef.current;
        if (slider) {
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 2;
            slider.scrollLeft = scrollLeft - walk;
        }
    };


    return (
        <div className="services-slider-container">
            <div className="services-slider-wrapper" ref={scrollRef}
            onMouseDown={handleMouseDown}
                onMouseLeave={handleMouseUp} // Optional: Reset on mouse leaving the container
                onMouseUp={handleMouseUp}
                onMouseMove={handleMouseMove}
            >
                {appData.apps &&  appData.apps.map((app, index) => (
                    <div className="app-card" key={index}>
                        <div className="card-header-app">
                            <div className="icon-container">
                              <img src={app.icon} alt={`${app.title} logo`} className="app-icon" style={{ width: '54px' }} />
                            </div> 
                            <h3 className="app-title">{app.title}</h3>
                        </div>

                        <div className="card-content-app">
                            <p className="app-description">{app.subtitle}</p>
                            <div className="app-buttons">
                                
                                {app.iosLink && (
                                <button
                                    className="app-store-button"
                                    onClick={() => window.open(app.iosLink, '_blank')}
                                >
                                    <img src={appStoreLogo} alt="App Store" />
                                    <span>App Store</span>
                                </button>
                            )}

                               {app.androidLink && (
                            <button
                                className="google-play-button"
                                onClick={() => window.open(app.androidLink, '_blank')}
                            >
                                <img src={googlePlayLogo} alt="Google Play" />
                                <span>Google Play</span>
                            </button>
                        )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AppList;